import { theme } from "../../../theme/theme";
import portalSettingsManager from "utils/portalSettingsManager";

// TODO: Review this post upgrading to tailwind to refactor,  to use tailwind classes instead of custom styles
export const SURVEY_COLORS = {
  TEXT_PRIMARY: theme.palette.common?.black,
  TEXT_SECONDARY: theme.palette.grey["500"],

  // Error color - Red with sufficient contrast (theme.palette.error.main or custom)
  ERROR: "#B30000", // WCAG AA: 6.48:1 on white
  WHITE: theme.palette.common?.white || "#ffffff",
  BLACK: theme.palette.common?.black || "#000000",
  // Border colors
  BORDER_DEFAULT: theme.palette.grey["300"], // #d8d8d8

  // Background colors
  BACKGROUND_WHITE: theme.palette.common?.white || "#ffffff",

  // Brand color
  PRIMARY: theme.palette.primary.main, // #007AB8
  BUTTON_PRIMARY: portalSettingsManager?.application?.common?.ibfThemeColor || "#00338D", // Custom brand color not in theme

  // Modal colors (custom gradient colors not in theme)
  GRADIENT_PURPLE: "#9333ea",
  GRADIENT_PURPLE_LIGHT: "#a855f7",
  GRADIENT_BLUE: "#3b82f6",
  MODAL_TEXT_WHITE: theme.palette.common?.white || "#ffffff",
  MODAL_ICON_BG: "rgba(255, 255, 255, 0.2)",
  MODAL_CLOSE_BG: "rgba(255, 255, 255, 0.1)",
  MODAL_CLOSE_HOVER: "rgba(255, 255, 255, 0.2)",
  MODAL_SPARKLE_1: "rgba(255, 255, 255, 0.2)",
  MODAL_SPARKLE_2: "rgba(217, 189, 255, 0.3)",
  MODAL_GRADIENT_OVERLAY:
    "linear-gradient(to bottom right, rgba(147, 51, 234, 0.5), rgba(59, 130, 246, 0.5))",

  // Card/Shadow colors
  BOX_SHADOW: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
  BUTTON_HOVER_BG: "rgba(0, 0, 0, 0.04)",

  // Other colors
  SELECT_BORDER: theme.palette.common?.black || theme.palette.grey["A100"] || "#000000",
};

// Typography
export const SURVEY_TYPOGRAPHY = {
  FONT_SIZE_LABEL: "14px",
  FONT_SIZE_ERROR: "12px",
  FONT_SIZE_HINT: "12px",
  FONT_SIZE_INPUT: "14px",

  FONT_WEIGHT_NORMAL: 400,
  FONT_WEIGHT_SEMIBOLD: 600,
  FONT_WEIGHT_BOLD: 700,

  LINE_HEIGHT_NORMAL: "21px",
  LINE_HEIGHT_COMPACT: "16px",
};

// Spacing
export const SURVEY_SPACING = {
  QUESTION_MARGIN_TOP: "27px",
  LABEL_PADDING_BOTTOM: "13px",
  LABEL_PADDING_LEFT: "15px",
  LABEL_TEXT_INDENT: "-15px",
  ERROR_MARGIN_TOP: "4px",
  ERROR_MARGIN_BOTTOM: "4px",
  BORDER_RADIUS: "10px",
};

// Common Style Mixins
export const SURVEY_MIXINS = {
  questionLabel: {
    fontSize: SURVEY_TYPOGRAPHY.FONT_SIZE_LABEL,
    color: SURVEY_COLORS.TEXT_PRIMARY,
    lineHeight: SURVEY_TYPOGRAPHY.LINE_HEIGHT_NORMAL,
    fontWeight: SURVEY_TYPOGRAPHY.FONT_WEIGHT_SEMIBOLD,
    display: "block",
    "& > *": {
      display: "inline",
    },
  },

  requiredAsterisk: {
    color: SURVEY_COLORS.ERROR,
    marginLeft: "6px",
    verticalAlign: "baseline",
  },

  optionLabel: {
    fontSize: SURVEY_TYPOGRAPHY.FONT_SIZE_LABEL,
    color: SURVEY_COLORS.TEXT_PRIMARY,
    lineHeight: SURVEY_TYPOGRAPHY.LINE_HEIGHT_NORMAL,
    fontWeight: SURVEY_TYPOGRAPHY.FONT_WEIGHT_SEMIBOLD,
  },

  errorBorder: {
    border: `2px solid ${SURVEY_COLORS.ERROR}`,
    borderRadius: "4px",
    padding: "8px",
    boxSizing: "border-box" as const,
    overflow: "hidden" as const,
    width: "100%",
    "& textarea": {
      maxWidth: "100%",
    },
  },

  inputBase: {
    fontSize: SURVEY_TYPOGRAPHY.FONT_SIZE_INPUT,
    fontFamily: "Arial, sans-serif",
    color: SURVEY_COLORS.TEXT_PRIMARY,
  },
};

// DatePicker specific styles
export const DATEPICKER_STYLES = {
  width: "350px",
  maxWidth: "100%",
  fontSize: SURVEY_TYPOGRAPHY.FONT_SIZE_INPUT,
  fontFamily: "Arial, sans-serif",
  backgroundColor: SURVEY_COLORS.BACKGROUND_WHITE,
};

// Dropdown specific styles
export const DROPDOWN_STYLES = {
  width: "350px",
  maxWidth: "100%",
  fontSize: SURVEY_TYPOGRAPHY.FONT_SIZE_INPUT,
  fontFamily: "Arial, sans-serif",
};

// TextArea specific styles
export const TEXTAREA_STYLES = {
  fontSize: SURVEY_TYPOGRAPHY.FONT_SIZE_INPUT,
  fontFamily: "Arial, sans-serif",
  padding: "8px",
};
